/**
 * ページの情報や各種一覧でIDを表示
 *
 * @param {Object} options
 * @param {Boolean} options.id `true` をセットするとIDをテーブルに表示します。
 *
 * 使用例:
 * debug();
 */
import { copyToClipboard } from './copyToClipboard.js';
import { makeField } from './makeField.js';
import { randomString } from './randomString.js';

export function debug() {
    // Show the page information
    // @ts-ignore
    const mtappVars = window.mtappVars;
    const body = document.body;
    const bodyID = body.id ? '#' + body.id.trim() : '';
    const bodyClass = '.' + body.className.replace(/ +/g, '.').trim();
    const mainContent = document.querySelector('.mt-mainContent');
    const pointer = document.getElementById('sortable');

    const insertCopiableTextarea = (label, textareaValue) => {
        const randomId = randomString();
        const fieldHtml = makeField({
            label: label,
            content: `
                    <textarea id="${randomId}" class="form-control font-monospace" style="height: 8rem">${textareaValue}</textarea>
                    <button type="button" id="copy-${randomId}" data-mtapp-copy-target-id="${randomId}" class="btn btn-default mt-3">クリップボードにコピー</button>`
        });
        pointer.insertAdjacentHTML('beforebegin', fieldHtml);
        document.getElementById(`copy-${randomId}`).addEventListener('click', (event) => {
            event.preventDefault();
            if (event.target instanceof HTMLElement) {
                copyToClipboard(event.target);
            }
        });
        return randomId;
    };

    console.warn('mtappVars', mtappVars);

    if (mainContent) {
        const fields = Array.from(mainContent.querySelectorAll('div.field')).filter((field) => {
            if (field instanceof HTMLElement) {
                return !(field.id && field.id.startsWith('id-')) && field.offsetWidth > 0 && field.offsetHeight > 0;
            }
            return false;
        });

        const fieldSort = [];

        fields.forEach((field) => {
            const basename = field.id.replace(/-field$/, '');
            fieldSort.push(basename);

            const input = document.createElement('input');
            input.type = 'text';
            input.value = basename;
            input.className = 'form-control font-monospace mt-4 mb-2 pl-2 bg-light border-light';
            input.disabled = true;
            input.readOnly = true;
            field.before(input);
        });

        insertCopiableTextarea('現在のフィールドの並び順', fieldSort.join(','));
    } else {
        document.getElementById('mtapp-show-basename').style.display = 'none';
    }

    // body の id と class を表示
    insertCopiableTextarea('body の id と class', `body${bodyID}${bodyClass}`);

    // 表示中のページに適用するための if 文を出力
    let conditions = [];
    if (mtappVars.screen_id === 'edit-content-type-data' && mtappVars.contentType) {
        conditions.push(
            `/* 「${mtappVars.contentType?.name}」コンテンツデータ編集画面 */\nif (Number(mtappVars.blog_id) === ${Number(mtappVars.blog_id)} && mtappVars.screen_id === 'edit-content-type-data' && mtappVars.contentType?.name === '${mtappVars.contentType?.name}') {}`
        );
        if (mtappVars.content_data) {
            conditions.push(
                `/* 「${mtappVars.contentType?.name}」コンテンツデータ編集画面（編集のみ） */\nif (Number(mtappVars.blog_id) === ${Number(mtappVars.blog_id)} && mtappVars.screen_id === 'edit-content-type-data' && mtappVars.contentType?.name === '${mtappVars.contentType?.name}' && mtappVars.content_data) {}`
            );
        } else {
            conditions.push(
                `/* 「${mtappVars.contentType?.name}」コンテンツデータ編集画面（新規のみ） */\nif (Number(mtappVars.blog_id) === ${Number(mtappVars.blog_id)} && mtappVars.screen_id === 'edit-content-type-data' && mtappVars.contentType?.name === '${mtappVars.contentType?.name}' && !mtappVars.content_data) {}`
            );
        }
    } else if (mtappVars.screen_id.startsWith('edit-') && mtappVars.type) {
        let objectName = '';
        switch (mtappVars.type) {
            case 'entry':
                objectName = '記事';
                break;
            case 'category':
                objectName = 'カテゴリ';
                break;
            case 'page':
                objectName = 'ページ';
                break;
            default:
                objectName = mtappVars.type;
        }
        conditions.push(
            `/* ${objectName}編集画面 */\nif (Number(mtappVars.blog_id) === ${Number(mtappVars.blog_id)} && mtappVars.screen_id === 'edit-${mtappVars.type}') {}`
        );
        if (mtappVars[mtappVars.type]) {
            conditions.push(
                `/* ${objectName}編集画面（編集のみ） */\nif (Number(mtappVars.blog_id) === ${Number(mtappVars.blog_id)} && mtappVars.screen_id === 'edit-${mtappVars.type}' && mtappVars.${mtappVars.type}) {}`
            );
        } else {
            conditions.push(
                `/* ${objectName}編集画面（新規のみ） */\nif (Number(mtappVars.blog_id) === ${Number(mtappVars.blog_id)} && mtappVars.screen_id === 'edit-${mtappVars.type}' && !mtappVars.${mtappVars.type}) {}`
            );
        }
    }
    if (conditions.length > 0 && pointer) {
        conditions.forEach((condition) => {
            insertCopiableTextarea('このページに適用する条件文', condition);
        });
    }
}
